import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import TextAreaModal from 'components/Modals/textAreaModal';
import * as actions from './actions';
import { useActions } from 'hooks/useActions';

export default function CommentReportModal({ comment, closeModal }) {
  const { reportComment } = useActions(actions);
  const { reportCommentSubmitting, reportCommentSuccess, reportCommentError } = useSelector((state) => state.comments);

  useEffect(() => {
    if (reportCommentSuccess) {
      closeModal();
    }
  }, [reportCommentSuccess, closeModal]);

  useEffect(() => {
    if (reportCommentError) {
      toast.error(reportCommentError);
    }
  }, [reportCommentError]);

  return (
    <TextAreaModal
      title="Report Comment"
      loading={reportCommentSubmitting}
      onCancel={closeModal}
      onSubmit={(feedback) => reportComment(comment._id, feedback)}
      placeholder="Write your report here"
    />
  );
}
